export const ContactsMergeStatus = {
  REQUEST: 'CONTACTS_MERGE_REQUEST',
  SUCCESS: 'CONTACTS_MERGE_SUCCESS',
  ERROR: 'CONTACTS_MERGE_ERROR',
  RESET: 'CONTACTS_MERGE_RESET',
};
